import { provideHttpClient, withInterceptors, withXsrfConfiguration } from '@angular/common/http';
import { ApplicationConfig, ErrorHandler, provideBrowserGlobalErrorListeners, provideZonelessChangeDetection } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withInMemoryScrolling, withNavigationErrorHandler, withRouterConfig, withViewTransitions } from '@angular/router';
import { NgxCurrencyConfig, NgxCurrencyInputMode, provideEnvironmentNgxCurrency } from 'ngx-currency';
import { NgxMaskConfig, provideNgxMask } from 'ngx-mask';
import { provideToastr } from 'ngx-toastr';
import { provideNgxWebstorage, withLocalStorage, withNgxWebstorageConfig, withSessionStorage } from 'ngx-webstorage';
import { routes } from './app.routes';
import { reloadOnStaleChunk } from './app.stale-chunk';
import { ErrorHandlerUser } from './error';
import { apiInterceptor } from './gateway';

const CURRENCY_CONFIG: NgxCurrencyConfig = {
  align: 'right',
  allowNegative: true,
  allowZero: true,
  thousands: '.',
  decimal: ',',
  precision: 2,
  prefix: '',
  suffix: '',
  nullable: false,
  inputMode: NgxCurrencyInputMode.Financial,
};

const MASK_CONFIG: Partial<NgxMaskConfig> = {
  dropSpecialCharacters: false,
};

const STORAGE_CONFIG = {
  prefix: 'erpclass-cob',
  separator: '.',
  caseSensitive: false,
};

export const appConfig: ApplicationConfig = {
  providers: [
    {
      provide: ErrorHandler,
      useClass: ErrorHandlerUser,
    },
    provideHttpClient(withInterceptors([apiInterceptor]), withXsrfConfiguration({ cookieName: 'XSRF-TOKEN', headerName: 'X-XSRF-TOKEN' })),
    provideAnimationsAsync(),
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(
      routes,
      withRouterConfig({
        onSameUrlNavigation: 'reload',
      }),
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
        anchorScrolling: 'enabled',
      }),
      withViewTransitions(),
      withNavigationErrorHandler(reloadOnStaleChunk)
    ),
    provideToastr(),
    provideNgxMask(MASK_CONFIG),
    provideEnvironmentNgxCurrency(CURRENCY_CONFIG),
    provideNgxWebstorage(withNgxWebstorageConfig(STORAGE_CONFIG), withLocalStorage(), withSessionStorage()),
  ],
};
